// extracted by mini-css-extract-plugin
export default {"root":"_6DDi7","content":"_3V3zv"};